export default __webpack_public_path__ + "static/media/materialize-7.b77201eb.jpg";